import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Bus, Target, ShieldCheck, MapPinned, Percent, MessageCircle, Search } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function AboutPage() {
  const values = [
    { icon: ShieldCheck, t: "Transparan & Aman", d: "Driver diverifikasi Admin, harga tampil jelas, dan seluruh order tercatat rapi." },
    { icon: Percent, t: "Adil untuk Driver", d: "Harga ditentukan Driver sendiri; komisi platform hanya 20% dari order via Travele." },
    { icon: MessageCircle, t: "Satu Jalur Resmi", d: "Semua pemesanan dibantu Admin melalui satu nomor WhatsApp agar tidak membingungkan." },
    { icon: Search, t: "Mudah Dibandingkan", d: "Papan jadwal digital menampilkan banyak pilihan travel dalam satu layar." },
  ];
  return (
    <div className="min-h-screen bg-background">
      <Seo
        path="/tentang-kami"
        title="Tentang Travele — Digital Terminal Travel Door to Door Indonesia"
        description="Travele adalah marketplace & Digital Terminal yang mempertemukan penyedia travel door to door dan charter drop off dengan penumpang antarkota di seluruh Indonesia."
      />
      <Navbar />
      <section className="border-b border-border bg-card">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
          <p className="flex items-center gap-2 font-mono-terminal text-xs uppercase tracking-widest text-primary"><Bus className="h-3.5 w-3.5" /> Tentang Kami</p>
          <h1 className="mt-2 font-display text-3xl font-black uppercase tracking-tighter sm:text-4xl lg:text-5xl">Digital Terminal Travel Indonesia</h1>
          <p className="mt-4 max-w-2xl leading-relaxed text-muted-foreground">
            Travele adalah marketplace dan Digital Terminal yang mempertemukan penyedia jasa Travel Door to Door serta Charter Drop Off dengan masyarakat yang membutuhkan transportasi antarkota. Kami menghadirkan pengalaman mencari travel semudah melihat papan jadwal keberangkatan di terminal atau bandara.
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6">
        <div className="grid gap-4 md:grid-cols-2">
          <div className="border border-border bg-card p-6">
            <Target className="h-7 w-7 text-primary" />
            <h2 className="mt-3 font-display text-xl font-bold">Misi Kami</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Menjadi pusat informasi jadwal keberangkatan travel door-to-door di seluruh Indonesia — membantu Driver mendapatkan penumpang dan memudahkan penumpang menemukan travel sesuai asal, tujuan, tanggal, harga, armada, dan jadwal.
            </p>
          </div>
          <div className="border border-border bg-card p-6">
            <MapPinned className="h-7 w-7 text-primary" />
            <h2 className="mt-3 font-display text-xl font-bold">Posisi Travele</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Travele adalah perantara digital, <b className="text-foreground">bukan</b> perusahaan travel, pemilik armada, atau operator kendaraan. Layanan transportasi diberikan langsung oleh Driver; Travele menampilkan jadwal, menerima order, memfasilitasi komunikasi, dan mencatat transaksi.
            </p>
          </div>
        </div>

        <h2 className="mb-6 mt-12 font-display text-2xl font-bold tracking-tight">Nilai yang Kami Pegang</h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v, i) => (
            <div key={i} className="border border-border bg-card p-5" data-testid={`about-value-${i}`}>
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-primary/15 text-primary"><v.icon className="h-5 w-5" /></div>
              <h3 className="font-display text-lg font-bold">{v.t}</h3>
              <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 border border-primary/40 bg-primary/5 p-8 text-center">
          <h2 className="font-display text-2xl font-bold">Siap bepergian atau bergabung sebagai Driver?</h2>
          <p className="mx-auto mt-2 max-w-xl text-muted-foreground">Cari jadwal travel di Digital Terminal, atau daftarkan armada Anda untuk mendapatkan penumpang.</p>
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            <Link to="/"><button data-testid="about-cari-btn" className="rounded-md bg-primary px-6 py-3 font-bold text-primary-foreground transition-transform hover:-translate-y-0.5">Cari Travel</button></Link>
            <Link to="/daftar"><button data-testid="about-daftar-btn" className="rounded-md border border-border px-6 py-3 font-semibold transition-colors hover:border-primary">Daftar Mitra Driver</button></Link>
          </div>
        </div>
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
